import { StyleSheet, Text } from "react-native";
import type { TextProps } from "react-native";

import { useCustomTheme } from "../hooks/useCustomTheme";

type ThemedTextProps = TextProps & {
  type?:
    | "default"
    | "title"
    | "defaultSemiBold"
    | "subtitle"
    | "headline"
    | "link"
    | "muted"
    | "danger"
    | "small";
};

export const ThemedText = ({
  style,
  type = "default",
  ...rest
}: ThemedTextProps) => {
  const { colors } = useCustomTheme();

  return (
    <Text
      style={[
        type === "link" ? { color: colors.info } : { color: colors.text },
        type === "default" ? styles.default : undefined,
        type === "title" ? styles.title : undefined,
        type === "defaultSemiBold" ? styles.defaultSemiBold : undefined,
        type === "subtitle" ? styles.subtitle : undefined,
        type === "headline" ? styles.headline : undefined,
        type === "link" ? styles.link : undefined,
        type === "muted" ? styles.muted : undefined,
        type === "small" ? styles.small : undefined,
        type === "danger"
          ? [styles.danger, { color: colors.danger }]
          : undefined,
        style,
      ]}
      {...rest}
    />
  );
};

const styles = StyleSheet.create({
  default: {
    fontSize: 16,
    lineHeight: 24,
  },
  defaultSemiBold: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: "600",
  },
  title: {
    fontSize: 32,
    fontWeight: "bold",
    lineHeight: 40,
  },
  subtitle: {
    fontSize: 20,
    fontWeight: "bold",
  },
  headline: {
    fontSize: 24,
    fontWeight: "bold",
  },
  link: {
    lineHeight: 30,
    fontSize: 16,
  },
  muted: {
    fontSize: 14,
    lineHeight: 18,
  },
  danger: {
    fontSize: 14,
    lineHeight: 18,
  },
  small: {
    fontSize: 12,
    lineHeight: 14.4,
  },
});
